import { Map } from 'immutable';
import {
    SET_DATA_VERIFY
} from '../../actions/relocation/relocationDCA';

const initialState = Map({
    dataVerify: false,
});

const actionsMap = {
    [SET_DATA_VERIFY]: (state, action) => {
      return state.set('dataVerify', action.dataVerify);
    },
  };

export default function facilities(state = initialState, action = {}) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
  }